/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.3.1 routes of GenomicsPlatform::Application.
 * @version b5881bc0830320a91e6f579a2d3340e6da0467ec10493b2075e543fab8f5467d
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /access_form
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accessFormPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"access_form"]]);

/**
 * Generates rails route to
 * /active_admin/access_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_requests/:access_request_id/access_request_changes/:id(.:format)
 * @param {any} accessRequestId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestAccessRequestChangePath = /*#__PURE__*/ __route({"access_request_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_requests"],[2,[7,"/"],[2,[3,"access_request_id"],[2,[7,"/"],[2,[6,"access_request_changes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_requests/:access_request_id/access_request_changes(.:format)
 * @param {any} accessRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestAccessRequestChangesPath = /*#__PURE__*/ __route({"access_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_requests"],[2,[7,"/"],[2,[3,"access_request_id"],[2,[7,"/"],[2,[6,"access_request_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_request_approvals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestApprovalsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_request_approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_request_changes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestChangePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_request_changes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_request_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestChangesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_request_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_request_drafts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestDraftPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_request_drafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_request_drafts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestDraftsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_request_drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessRequestsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_units/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessUnitPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_units/:access_unit_id/repo_files/:id(.:format)
 * @param {any} accessUnitId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessUnitRepoFilePath = /*#__PURE__*/ __route({"access_unit_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_units"],[2,[7,"/"],[2,[3,"access_unit_id"],[2,[7,"/"],[2,[6,"repo_files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_units/:access_unit_id/repo_files(.:format)
 * @param {any} accessUnitId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessUnitRepoFilesPath = /*#__PURE__*/ __route({"access_unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_units"],[2,[7,"/"],[2,[3,"access_unit_id"],[2,[7,"/"],[2,[6,"repo_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/access_units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminAccessUnitsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"access_units"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/approved_clinicalgenomics_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminApprovedClinicalgenomicsUsersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"approved_clinicalgenomics_users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/archived_access_unit_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminArchivedAccessUnitJobPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"archived_access_unit_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/archived_access_unit_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminArchivedAccessUnitJobsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"archived_access_unit_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminCommentPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminCommentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminDashboardPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/developer_tools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminDeveloperToolsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"developer_tools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/foreign_user_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminForeignUserRequestsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"foreign_user_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/pecan_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminPecanRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"pecan_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/pecan_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminPecanRequestsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"pecan_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/repo_files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminRepoFilePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"repo_files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/repo_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminRepoFilesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"repo_files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /active_admin/time_until_first_decision(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminTimeUntilFirstDecisionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"time_until_first_decision"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/tools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminToolPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/tools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminToolsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminUserPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/users/:user_id/access_requests/:id(.:format)
 * @param {any} userId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminUserAccessRequestPath = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"access_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/users/:user_id/access_request_drafts/:id(.:format)
 * @param {any} userId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminUserAccessRequestDraftPath = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"access_request_drafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/users/:user_id/access_request_drafts(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminUserAccessRequestDraftsPath = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"access_request_drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/users/:user_id/access_requests(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminUserAccessRequestsPath = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"access_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeAdminUsersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"active_admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /addendum_form
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addendumFormPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"addendum_form"]]);

/**
 * Generates rails route to
 * /api/*path
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiPath = /*#__PURE__*/ __route({"path":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[5,[3,"path"]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_requests/:id/access_request_addendum_forms(/:access_request_addendum_form_id)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AccessRequestAddendumFormsPath = /*#__PURE__*/ __route({"id":{"r":true},"access_request_addendum_form_id":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"access_request_addendum_forms"],[1,[2,[7,"/"],[3,"access_request_addendum_form_id"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_request_forms/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AccessRequestFormPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_request_forms"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_requests/:id/access_request_forms(/:access_request_form_id)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AccessRequestFormsPath = /*#__PURE__*/ __route({"id":{"r":true},"access_request_form_id":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"access_request_forms"],[1,[2,[7,"/"],[3,"access_request_form_id"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_units/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AccessUnitPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_units"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_units
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AccessUnitsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"access_units"]]]]]]);

/**
 * Generates rails route to
 * /api/v1/data_access_agreements/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DataAccessAgreementPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"data_access_agreements"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/data_access_agreements
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DataAccessAgreementsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"data_access_agreements"]]]]]]);

/**
 * Generates rails route to
 * /api/v1/graphql
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1GraphQLPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"graphql"]]]]]]);

/**
 * Generates rails route to
 * /api/v1/manifest
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ManifestPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"manifest"]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pecan/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1PecanIndexPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pecan"],[2,[7,"/"],[6,"new"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pecan_requests
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1PecanRequestsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"pecan_requests"]]]]]]);

/**
 * Generates rails route to
 * /api/v1/data_access_agreements/:id/check
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkAPIV1DataAccessAgreementPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"data_access_agreements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/envelopes/data_access_agreement
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataAccessAgreementAPIV1EnvelopesPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"envelopes"],[2,[7,"/"],[6,"data_access_agreement"]]]]]]]]);

/**
 * Generates rails route to
 * /dnanexus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dnanexusPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dnanexus"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dnanexus/projects/:dxid(.:format)
 * @param {any} dxid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dnanexusProjectPath = /*#__PURE__*/ __route({"dxid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dnanexus"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"dxid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dnanexus/projects/:dxid/data(.:format)
 * @param {any} dxid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dnanexusProjectDataPath = /*#__PURE__*/ __route({"dxid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dnanexus"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"dxid"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dnanexus/projects/:dxid/monitor(.:format)
 * @param {any} dxid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dnanexusProjectMonitorPath = /*#__PURE__*/ __route({"dxid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dnanexus"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"dxid"],[2,[7,"/"],[2,[6,"monitor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dnanexus/projects/:dxid/workflows/:workflowDxid(.:format)
 * @param {any} dxid
 * @param {any} workflowDxid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dnanexusProjectWorkflowPath = /*#__PURE__*/ __route({"dxid":{"r":true},"workflowDxid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dnanexus"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"dxid"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflowDxid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dnanexus/user/*dxid/billing(.:format)
 * @param {any} dxid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dnanexusUserBillingPath = /*#__PURE__*/ __route({"dxid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dnanexus"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[5,[3,"dxid"]],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentationPath = /*#__PURE__*/ __route({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documentation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentationBasePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/envelopes/extension_addendum
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extensionAddendumAPIV1EnvelopesPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"envelopes"],[2,[7,"/"],[6,"extension_addendum"]]]]]]]]);

/**
 * Generates rails route to
 * /graphiql
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphiqlRailsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"graphiql"]]);

/**
 * Generates rails route to
 * /letter_opener
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letterOpenerWebPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"letter_opener"]]);

/**
 * Generates rails route to
 * /letter_opener/clear(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letterOpenerWebClearLettersPath = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"letter_opener"]],[7,"/"]],[2,[6,"clear"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /letter_opener/:id/delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letterOpenerWebDeleteLetterPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"letter_opener"]],[7,"/"]],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /letter_opener/:id(/:style)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letterOpenerWebLetterPath = /*#__PURE__*/ __route({"id":{"r":true},"style":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"letter_opener"]],[7,"/"]],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"style"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /letter_opener/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letterOpenerWebLettersPath = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[6,"letter_opener"]],[7,"/"]]);

/**
 * Generates rails route to
 * /api/v1/access_requests/:id/access_request_addendum_forms/new
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAPIV1AccessRequestAddendumFormsPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"access_request_addendum_forms"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tools/pecan_pie(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pecanPiePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"pecan_pie"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsHealthCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoNotesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoPropertiesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoRoutesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_unit_jobs/:id/report
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportAPIV1AccessUnitJobPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_unit_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"report"]]]]]]]]]]);

/**
 * Generates rails route to
 * /return_from_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const returnFromLoginPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"return_from_login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /api/v1/pecan/samples
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const samplesAPIV1PecanIndexPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pecan"],[2,[7,"/"],[6,"samples"]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiqWebPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/current_user/tos
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tosAPIV1CurrentUserIndexPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[6,"tos"]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_request_drafts/:id/upload_manual_access_agreement
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadManualAccessAgreementAPIV1AccessRequestDraftPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_request_drafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_manual_access_agreement"]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/auth0(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAuth0OmniauthAuthorizePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"auth0"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/auth0/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAuth0OmniauthCallbackPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"auth0"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/dnanexus_hidden(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDNAnexusHiddenOmniauthAuthorizePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"dnanexus_hidden"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/dnanexus_hidden/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDNAnexusHiddenOmniauthCallbackPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"dnanexus_hidden"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/dnanexus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDNAnexusOmniauthAuthorizePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"dnanexus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/dnanexus/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDNAnexusOmniauthCallbackPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"dnanexus"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/dnanexus/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthDNAnexusRegisterPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"dnanexus"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthLogoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /visualizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visualizationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"visualizations"],[1,[2,[8,"."],[3,"format"]]]]]);

